import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import {
  type ReportAccessSubmitActionEnum,
  ReportAccessSubmitActions,
} from '../../enums'

export interface ReportAccessSubmitActionOption {
  value: ReportAccessSubmitActionEnum
  label: string
}

export const useReportAccessSubmitActionOptions =
  (): ReportAccessSubmitActionOption[] => {
    const intl = useProcurifyIntl()

    return [
      {
        value: ReportAccessSubmitActions.ADD,
        label: intl.formatMessage(messages.addOptionLabel),
      },
      {
        value: ReportAccessSubmitActions.REMOVE,
        label: intl.formatMessage(messages.removeOptionLabel),
      },
    ]
  }
